import { Injectable, inject, computed } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { ErrorStore } from '@state/error/error.store';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);
  private readonly errorStore = inject(ErrorStore);

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const requiredRoles = route.data['roles'] as string[]; // Roles from route metadata

    const userHasRole = computed(() => {
      const roles = this.authService.roles();
      return roles.some((role) => requiredRoles.includes(role));
    });

    if (!userHasRole()) {
      this.errorStore.showUnauthorized();
      this.router.navigate(['/home']);
      return false;
    }

    return true;
  }
}
